// This file contains the endpoint definitions that are imported
// into the environment.x.ts files in the same folder.

export const ENDPOINTS = {
	userLoginEnd: {
		path: 'login',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	userSSOLoginEnd: {
		path: 'ssologin',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	resetPasswordEnd: {
		path: 'changepassword',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	forgotPasswordEnd: {
		path: 'forgotpassword',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	userPasswordEnd: {
		path: 'updatepwd',
		access: ['anon', '', 'readonly', 'fa']
	},
	userRefreshTokenEnd: {
		path: 'token',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	poListEnd: {
		path: 'getcontractlist',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	downloadPOsEnd: {
		path: 'contracts/csv',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	archivedPOListEnd: {
		path: 'archived',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	archivePOsEnd: {
		path: 'archive',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	restorePOsEnd: {
		path: 'restore',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	archiveContractorsEnd: {
		path: 'contractor/archive',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	restoreContractorsEnd: {
		path: 'contractor/restore',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	archiveInvoicesEnd: {	// supplier invoices
		path: 'archiveinvoice',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	archiveInvoiceReconciliationsEnd: {
		path: 'invoicereconciliation/archive',
		access: ['fa']
	},
	restoreInvoiceReconciliationsEnd: {
		path: 'invoicereconciliation/restore',
		access: ['fa']
	},
	poDetailsEnd: {
		path: 'getcontract',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	poEnd: {
		path: 'contract',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'readonly', 'fa']
	},
	migrationCancellationList: {
		path: 'migrationcancellationlist',
		access: ['pm', 'sam', 'cca']
	},
	contractorDetailsEnd: {
		path: 'getcontractor',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'contractor', 'tra', 'readonly', 'fa']
	},
	contractorListEnd: {
		path: 'getcontractorlist',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	downloadContractorsEnd: {
		path: 'contractors/csv',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	pendingContractorListEnd: {
		path: 'nonapprovedcontractorlist',
		access: ['sa', 'pm', 'sam', 'cca', 'readonly', 'fa']
	},
	contractorEnd: {
		path: 'contractor',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	poCalendarEnd: {
		path: 'assigninvcal',
		access: ['sa', 'sam']
	},
	approveContractorEnd: {
		path: 'approvecontractor',
		access: ['sa', 'pm', 'sam', 'srm', 'cca']
	},
	warrantContractorEnd: {
		path: 'contractor/warranty',
		access: ['pm', 'fa']
	},
	mergeContractorEnd: {
		path: 'mergecontractor',
		access: ['sa', 'pm', 'sam', 'srm', 'cca']
	},
	pendingTimesheetsEnd: {
		path: 'pendingtimesheetsbyuser',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	escalatedTimesheetsEnd: {
		path: 'timesheets/escalations',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	timesheetEnd: {
		path: 'timesheet',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	timesheetReasonEnd: {
		path: 'timesheet/edit',
		access: ['sam', 'contractor']
	},
	migrateTimesheetsEnd: {
		path: 'migratetimesheets',
		access: ['pm', 'tra', 'fa']
	},
	migrateCancelledPOEnd: {
		path: 'migratecancelleddata',
		access: ['pm', 'sam', 'cca']
	},
	timesheetsEnd: {
		path: 'timesheets',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	downloadTimesheetsEnd: {
		path: 'timesheets/csv',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	timesheetApprovalEnd: {
		path: 'approvetimesheet',
		access: ['sa', 'pm', 'sam', 'tra']
	},
	timesheetArchiveEnd: {
		path: 'timesheet/archive',
		access: ['sam', 'contractor']
	},
	timesheetRestoreEnd: {
		path: 'timesheet/restore',
		access: ['sam', 'contractor']
	},
	timesheetsApprovalEnd: {
		path: 'approvetimeswithqueue',
		access: ['sa', 'pm', 'sam', 'tra']
	},
	accountEnd: {
		path: 'account',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	accountsEnd: {
		path: 'allaccounts',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	quantityTypesEnd: {
		path: 'quantity_types',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	hoursRestrictionEnd: {
		path: 'hour_restrictions',
		access: ['sa', 'pm', 'sam', 'srm', 'readonly']
	},
	hoursRestrictionDeleteEnd: {
		path: 'hour_restrictions',
		access: ['sa', 'pm']
	},
	usersByRoleEnd: {
		path: 'queryuserlist',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	authenticationRoleEnd: {
		path: 'login/auth/role',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	userKeysEnd: {
		path: 'getKeys',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	tokenInfoEnd: {
		path: 'token/info',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	assignAccountsEnd: {
		path: 'contractoraccounts',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	poDelegationEnd: {
		path: 'contractdelegation',
		access: ['sa', 'pm', 'sam', 'cca']
	},
	contractorDelegationEnd: {
		path: 'contractordelegation',
		access: ['sa', 'pm', 'sam', 'cca']
	},
	queueItemsEnd: {
		path: 'userqueue',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	ilcReasonCodesEnd: {
		path: 'ilc/reasoncodes',
		access: ['sa', 'pm', 'sam', 'tra', 'contractor', 'readonly', 'fa']
	},
	ilcAccountsEnd: {
		path: 'ilcaccounts',
		access: ['contractor', 'sam']
	},
	sowEnd: {
		path: 'statements_of_work',
		access: ['sa', 'sam', 'srm', 'readonly']
	},
	rateEnd: {
		path: 'rate_changes',
		access: ['sa', 'sam', 'srm', 'readonly']
	},
	termsEnd: {
		path: 'contracts_payterms',
		access: ['sa', 'sam', 'srm', 'readonly']
	},
	smartContractsListEnd: {
		path: 'smartcontractlistview',
		access: ['sa', 'pm', 'sam', 'srm', 'readonly']
	},
	pendingSmartContractsListEnd: {
		path: 'nonapprovedsmartcontracts',
		access: ['sa', 'sam', 'readonly']
	},
	smartContractsApproveEnd: {
		path: 'approvesmartcontracts',
		access: ['sa', 'pm', 'sam', 'srm', 'readonly']
	},
	// smartContractsListEnd: 'nonapprovedsmartcontracts',
	pendingUserRequests: {
		path: 'queryuserrequests',
		access: ['admin', 'sa', 'readonly']
	},
	users: {
		path: 'users',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly']
	},
	expiringusers: {
		path: 'expiringusers',
		access: ['admin', 'sa', 'readonly']
	},
	revokeusers: {
		path: 'revokeusers',
		access: ['admin', 'sa']
	},
	revalidateusers: {
		path: 'validateuser',
		access: ['admin', 'sa']
	},
	createusers: {
		path: 'registerusers',
		access: ['admin', 'sa']
	},
	userEnd: {
		path: 'user',
		access: ['admin', 'sa']
	},
	registeruser: {
		path: 'registeruser',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly'],
	},
	documentEnd: {
		path: 'document',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	documentsEnd: {
		path: 'documents',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	addonsContractorEnd: {
		path: 'contractoraddon',
		access: ['admin', 'sa', 'pm', 'sam', 'cca', 'tra']
	},
	addonsContractorDeleteEnd: {
		path: 'deletecontractoraddon',
		access: ['admin', 'sa', 'pm', 'sam', 'cca']
	},
	pendingActionsEnd: {
		path: 'pendingActions',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'readonly', 'fa']
	},
	recordConfig: {
		path: 'config',
		access: ['admin', 'sa']
	},
	getAllConfig: {
		path: 'getconfiglist',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	retrieveConfig: {
		path: 'config',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	invoiceCalListEnd: {
		path: 'getcalconfiglist',
		access: ['sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	invoiceCalEnd: {
		path: 'calconfig',
		access: ['admin', 'sa']
	},
	retrieveCalConfig: {
		path: 'getcalconfig',
		access: ['admin', 'sa']
	},
	invoiceCalDeleteEnd: {
		path: 'calconfig',
		access: ['admin', 'sa']
	},
	privacyAgreement: {
		path: 'privacy-statement',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	invoiceEnd: {
		path: 'invoice',
		access: ['sam', 'readonly', 'fa']
	},
	invoiceSubmitEnd: {
		path: 'invoice',
		access: ['admin']
	},
	invoiceSupSubmitEnd: {
		path: 'supinvoice',
		access: ['admin']
	},
	invoiceListEnd: {
		path: 'getinvoicesreconciliationlist',
		access: ['pm', 'sam', 'cca', 'readonly', 'fa']
	},
	downloadInvoicesEnd: {
		path: 'invoicesreconciliation/csv',
		access: ['pm', 'sam', 'cca', 'readonly', 'fa']
	},
	supplierInvoiceListEnd: {
		path: 'getsupplierinvoiceslist',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	downloadSupplierInvoicesEnd: {
		path: 'supplierinvoices/csv',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	supplierInvoiceDetailsEnd: {
		path: 'getsupplierinvoice',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	bcInvoiceDetailsEnd: {
		path: 'getbcinvoice',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	bcInvoiceListEnd: {
		path: 'getbcinvoiceslist',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	downloadBCInvoicesEnd: {
		path: 'bcinvoices/csv',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	invoiceReconciliationEnd: {
		path: 'getinvoicereconciliation',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	invoiceFailureReasonsEnd: {
		path: 'failurereasons',
		access: ['pm', 'sam', 'readonly', 'fa']
	},
	invoiceCommentsUpdateEnd: {
		path: 'invoicereconciliation/comments',
		access: ['fa']
	},
	invoiceReconcilEnd: {
		path: 'generateinvoices',
		access: ['fa']
	},
	userConfigsEnd: {
		path: 'userconfigs',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	countryCodesEnd: {
		path: 'allcountrycodes',
		access: ['admin', 'cca', 'pm', 'tra', 'fa', 'sam', 'readonly']
	},
	countriesEnd: {
		path: 'countries',
		access: [, 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', 'readonly', 'fa']
	},
	divisionCodesEnd: {
		path: 'alldivisioncodes',
		access: ['admin', 'cca', 'pm', 'fa', 'tra', 'sam', 'readonly']
	},
	suppliersEnd: {
		path: 'suppliers',
		access: ['admin', 'cca', 'pm', 'fa', 'sam', 'tra', 'readonly']
	},
	forceReconciliation: {
		path: 'forcereconciliation',
		access: ['fa']
	},
	invoiceReports: {
		path: 'invoicereports',
		access: ['fa', 'pm', 'sam']
	},
	rejectSupplierInvoices: {
		path: 'rejectsupplierinvoices',
		access: ['fa']
	},
	getRejectReasons: {
		path: 'rejectreasons',
		access: ['fa']
	},
	liabilityReports: {
		path: 'accrualreports',
		access : ['fa', 'pm', 'sam']
	},
	timesheetReports: {
		path: 'ilchoursreport',
		access : ['pm', 'tra']
	},
	poReports: {
		path: 'poremainingfunds',
		access : ['pm', 'sam', 'cca', 'fa', 'readonly']
	},
	contractorReports: {
		path: 'contractorreport',
		access : ['pm', 'sam', 'cca', 'fa', 'readonly']
	},
	activeContractorReports: {
		path: 'contractors/csv',
		access : ['readonly']
	},
	contractorNoTSReports: {
		path: 'contractornots',
		access : ['sam', 'pm', 'tra', 'cca', 'readonly']
	},
	contractorMissTSReports: {
		path: 'contractors/missingtimesheets',
		access : ['sam', 'pm', 'tra', 'fa', 'readonly']
	},
	scheduledDTVs: {
		path: 'dtvSchedule',
		access : ['pm', 'cca']
	},
	dashboard: {
		path: 'dashboard',
		access : ['pm', 'sam', 'contractor']
	},
	releaseNotes: {
		path: 'releasenote',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	nonbillableCodes: {
		path: 'nonbillablecodes',
		access: ['admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	announcements: {
		path: 'announcements',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	bankHolidaysEnd: {
		path: 'bankingholidays',
		access: ['contractor', 'sam']
	},
	loginHelp: {
		path: 'loginhelp',
		access: ['anon', 'admin', 'sa', 'pm', 'sam', 'srm', 'cca', 'tra', 'contractor', '', 'readonly', 'fa']
	},
	contractorBulk: {
		path: ['contractorbulk'],
		access: ['cca']
	}
};
